import { PaginatedAPIResponse, APIResponse } from "../models/NetworkResponse";
import { Employee, Resetpassword } from "../models/Employees/Employee";
import { deleteAPI, getAPI, postAPI, putAPI } from "./Networking";
import { GetEmployeeParams } from "../models/Employees/GetEmployeeParams";

export default class EmployeeAPI {
  fetchEmployee = async (
    params: GetEmployeeParams
  ): Promise<PaginatedAPIResponse<Employee>> => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page_no)
        queryParams.append("page_no", params.page_no.toString());
      if (params.limit) queryParams.append("limit", params.limit.toString());
      if (params.sortBy) queryParams.append("sort_by", params.sortBy);
      if (params.sortType)
        queryParams.append("sort_type", params.sortType.toString());
      if (params.search_text)
        queryParams.append("search_text", params.search_text);
      if (params.team_id) queryParams.append("team_id", params.team_id.id);
      if (params.active && params.active.length > 0)
        queryParams.append(
          "active",
          params.active.map((v) => (v === 1 ? "true" : "false")).join(","),
        );
      const response = await getAPI(`/v5/admins?${queryParams.toString()}`);
      // const response = await getAPI(`/v5/admins?${queryParams.toString()}`);
      return response.result as PaginatedAPIResponse<Employee>;
    } catch (error) {
      throw error;
    }
  };

  getEmployee = async (
    params: GetEmployeeParams
  ): Promise<PaginatedAPIResponse<Employee>> => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page_no)
        queryParams.append("page_no", params.page_no.toString());
      if (params.limit) queryParams.append("limit", params.limit.toString());
      if (params.sortBy) queryParams.append("sort_by", params.sortBy);
      if (params.sortType)
        queryParams.append("sort_type", params.sortType.toString());
      if (params.search_text)
        queryParams.append("search_text", params.search_text);
      if (params.active && params.active.length > 0)
        queryParams.append(
          "active",
          params.active.map((v) => (v === 1 ? "true" : "false")).join(","),
        );
      const response = await getAPI(
        `/v5/admins/view?${queryParams.toString()}`
      );
      // const response = await getAPI(`/v5/admins?${queryParams.toString()}`);
      return response.result as PaginatedAPIResponse<Employee>;
    } catch (error) {
      throw error;
    }
  };

  editEmployee = async (employeeDetails?: Employee): Promise<APIResponse> => {
    try {
      const response = await putAPI(
        `/v5/admins/admin/details`,
        employeeDetails
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  getEditedEmployees = async (): Promise<APIResponse> => {
    try {
      const response = await getAPI(`/v5/admins/admin/details`);
      return response;
    } catch (error) {
      throw error;
    }
  };
  getAdminDetails = async (adminId: number): Promise<APIResponse> => {
    try {
      const response = await getAPI(
        `/v5/admins/admin/admin-id/${adminId}/details`
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
  teamPermission = async (adminId: number): Promise<APIResponse> => {
    try {
      const response = await getAPI(
        `/v5/admins/admin/admin-id/${adminId}/team/permissions`
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  getAllTeam = async (): Promise<APIResponse> => {
    try {
      const response = await getAPI(`/v5/admins/teams`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  addEmployee = async (employeeDetails: Employee): Promise<APIResponse> => {
    try {
      const response = await postAPI(`/v5/admins/admin`, employeeDetails);
      return response;
    } catch (error) {
      throw error;
    }
  };

  resetPassword = async (email: Resetpassword): Promise<APIResponse> => {
    try {
      const response = await postAPI(`/admin/sendPasswordRecoveryLink`, {
        email: email,
      });
      return response;
    } catch (error) {
      throw error;
    }
  };

  deleteEmployee = async (employeeId: number): Promise<APIResponse> => {
    try {
      const response = await deleteAPI(
        `/v5/admins/admin/admin-id/${employeeId}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
}
